import { validateVendor } from '@/core/validators';
import validateFromAndToAddresses from './fromAndToAddresses';
import validateEtdAndEta from './etdAndEta';
import validateAtdAndAta from './atdAndAta';
import validateLegs from './legs';

export default function validateTrip(trip, { validateDrivers }) {
	let allowEqualAddresses = Boolean(trip.type.internalCode === 'L');

	let tripErrors = {
		...validateFromAndToAddresses(trip, allowEqualAddresses),
		...validateEtdAndEta(trip),
		...validateAtdAndAta(trip),
		vendor: validateVendor(trip.vendor),
	};
	tripErrors.isInvalid = Object.values(tripErrors).reduce((acc, v) => acc || Boolean(v), false);

	let legsErrors = validateLegs(trip.legs, { validateDrivers, allowEqualAddresses: true });
	return {
		...tripErrors,
		legs: legsErrors.legs,
		isInvalid: tripErrors.isInvalid || legsErrors.isInvalid
	};
}
